if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.updateHiddenProperties();
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    updateHiddenProperties() {
        const sizeMap = {
            "EU32": "US0(Bust:32inch / 81cm, Waist:25½inch / 65cm, Hips:35½inch / 90cm, Hollow to Hem:",
            "EU34": "US2(Bust:33inch / 84cm, Waist:26½inch / 67cm, Hips:36½inch / 93cm, Hollow to Hem:",
            "EU36": "US4(Bust:34inch / 86cm, Waist:27½inch / 70cm, Hips:37½inch / 95cm, Hollow to Hem:",
            "EU38": "US6(Bust:35inch / 89cm, Waist:28½inch / 72cm, Hips:38½inch / 98cm, Hollow to Hem:",
            "EU40": "US8(Bust:36inch / 91cm, Waist:29½inch / 75cm, Hips:39½inch / 100cm, Hollow to Hem:",
            "EU42": "US10(Bust:37½inch / 95cm, Waist:31inch / 79cm, Hips:41inch / 104cm, Hollow to Hem:",
            "EU44": "US12(Bust:39inch / 99cm, Waist:32½inch / 83cm, Hips:42½inch / 108cm, Hollow to Hem:",
            "EU46": "US14(Bust:41¼inch / 104cm, Waist:34¼inch / 88cm, Hips:44½inch / 113cm, Hollow to Hem:",
            "EU48": "US16(Bust:43¼inch / 110cm, Waist:37¼inch / 95cm, Hips:46¾inch / 119cm, Hollow to Hem:",
            "EU50": "US18(Bust:45½inch / 116cm, Waist:39¾inch / 101cm, Hips:49inch / 124cm, Hollow to Hem:",
            "EU52": "US20(Bust:47¾inch / 121cm, Waist:42¼inch / 107cm, Hips:51¼inch / 130cm, Hollow to Hem:",
            "EU54": "US22(Bust:50inch / 127cm, Waist:44¾inch / 114cm, Hips:53½inch / 136cm, Hollow to Hem:",
            "EU56": "US24(Bust:53inch / 135cm, Waist:48inch / 122cm, Hips:56½inch / 144cm, Hollow to Hem:",
            "EU58": "US26(Bust:56inch / 142cm, Waist:51¼inch / 130cm, Hips:59½inch / 151cm, Hollow to Hem:",
            "EU60": "US28(Bust:59inch / 150cm, Waist:54½inch / 138cm, Hips:62½inch / 159cm, Hollow to Hem:",
            "EU62": "US30(Bust:63inch / 160cm, Waist:58¾inch / 149cm, Hips:66½inch / 169cm, Hollow to Hem:",
            "J4": "J4(Bust:22inch / 56cm, Waist:20inch / 51cm, Hips:25inch / 64cm, Hollow to Hem:",
            "J6": "J6(Bust:24inch / 61cm, Waist:22inch / 56cm, Hips:27inch / 69cm, Hollow to Hem:",
            "J8": "J8(Bust:26inch / 66cm, Waist:24inch / 61cm, Hips:29inch / 74cm, Hollow to Hem:",
            "J10": "J10(Bust:28inch / 71cm, Waist:26inch / 66cm, Hips:31inch / 79cm, Hollow to Hem:",
            "J12": "J12(Bust:30inch / 76cm, Waist:28inch / 71cm, Hips:33inch / 84cm, Hollow to Hem:",
            "J14": "J14(Bust:32inch / 81cm, Waist:30inch / 76cm, Hips:35inch / 89cm, Hollow to Hem:",
            "J16": "J16(Bust:34inch / 86cm, Waist:32inch / 81cm, Hips:37inch / 94cm, Hollow to Hem:",
            "2": "2(Bust:20¾inch / 53cm, Waist:20inch / 51cm, Hips:20inch / 51cm, Shoulder To Floor:",
            "3": "3(Bust:22inch / 56cm, Waist:20¾inch / 53cm, Hips:20¾inch / 53cm, Shoulder To Floor:",
            "4": "4(Bust:22¾inch / 58cm, Waist:22inch / 56cm, Hips:22inch / 56cm, Shoulder To Floor:",
            "5": "5(Bust:24inch / 61cm, Waist:22¾inch / 58cm, Hips:22¾inch / 58cm, Shoulder To Floor:",
            "6": "6(Bust:25¼inch / 64cm, Waist:24inch / 61cm, Hips:25¼inch / 64cm, Shoulder To Floor:",
            "7": "7(Bust:26inch / 66cm, Waist:25¼inch / 64cm, Hips:26inch / 66cm, Shoulder To Floor:",
            "8": "8(Bust:27¼inch / 69cm, Waist:26inch / 66cm, Hips:27¼inch / 69cm, Shoulder To Floor:",
            "9": "9(Bust:28inch / 71cm, Waist:27¼inch / 69cm, Hips:29¼inch / 74cm, Shoulder To Floor:",
            "10": "10(Bust:29¼inch / 74cm, Waist:28inch / 71cm, Hips:31inch / 79cm, Shoulder To Floor:",
            "11": "11(Bust:30¼inch / 77cm, Waist:29¼inch / 74cm, Hips:33inch / 84cm, Shoulder To Floor:",
            "12": "12(Bust:32inch / 81cm, Waist:30inch / 76cm, Hips:33¾inch / 86cm, Shoulder To Floor:",
            "13": "13(Bust:33inch / 84cm, Waist:31inch / 79cm, Hips:34¾inch / 88cm, Shoulder To Floor:",
            "14": "14(Bust:33¾inch / 86cm, Waist:32inch / 81cm, Hips:35inch / 89cm, Shoulder To Floor:"
        };

        const checkedSizeInput = document.querySelector('input[name="properties\\[Taille\\]"]:checked');
        const hiddenSizeInput = document.querySelector('input[name="properties\\[_Size_US\\]"]');

        if (checkedSizeInput && hiddenSizeInput) {
          hiddenSizeInput.value = "";
          const spanElement = checkedSizeInput.nextElementSibling;
          const lengthValue = checkedSizeInput.getAttribute('data-length');
          
          if (spanElement && spanElement.tagName === 'SPAN') {
              const ukSizeText = spanElement.innerText.trim(); 
              const usSize = sizeMap[ukSizeText] || ukSizeText;
              hiddenSizeInput.value = usSize + lengthValue + ")"; 
          }
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
